exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-transition {\n  transition: opacity .3s ease;\n}\n.fade-enter,\n.fade-leave {\n  height: 0;\n  opacity: 0;\n}\n.alert.top {\n  position: fixed;\n  top: 30px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  z-index: 1050;\n}\n.alert.top-right {\n  position: fixed;\n  top: 30px;\n  right: 50px;\n  z-index: 1050;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-1d348352&file=Alert.vue!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Alert.vue
// module id = 99
// module chunks = 0